import React from "react";
import { useLanguage } from "../../../context/LanguageContext";

const NewAcoustic = (): React.ReactElement => {
  const { t } = useLanguage();
  
  return (
    <div>
      <h1>{t('pages.acoustic.newOffer')}</h1>
      <p>{t('common.welcome')}</p>
    </div>
  );
};

export default NewAcoustic;